import script from "./novaClasse.vue?vue&type=script&setup=true&lang=js"
export * from "./novaClasse.vue?vue&type=script&setup=true&lang=js"

import "./novaClasse.vue?vue&type=style&index=0&id=9829b5fe&lang=css"

const __exports__ = script;

export default __exports__